export default __webpack_public_path__ + "static/women-logo-light-fec1f0fefa0a5a9bfd929b173472cbcc.png";